import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const COLORS = ['#4CAF50', '#FF9800', '#F44336', '#9E9E9E'];

const TaskStatusChart = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="chart-loading">
        <p>Loading task status data...</p>
      </div>
    );
  }

  if (!data || Object.keys(data).length === 0) {
    return (
      <div className="no-data-message">
        <p>No task status data available. Create and assign tasks to see distribution.</p>
      </div>
    );
  }

  // Transform object data to array for pie chart
  const chartData = Object.entries(data).map(([name, value]) => ({
    name,
    value
  })).filter(item => item.value > 0);

  if (chartData.length === 0) {
    return (
      <div className="no-data-message">
        <p>No tasks available. Create and assign tasks to see distribution.</p>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <PieChart>
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          labelLine={true}
          label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
          outerRadius={120}
          fill="#8884d8"
          dataKey="value"
        >
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip 
          contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            padding: '12px',
          }}
          formatter={(value) => [`${value} tasks`, 'Count']}
        />
        <Legend 
          verticalAlign="bottom"
          height={36}
          iconType="circle"
        />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default TaskStatusChart;
